import React from "react";

import { i18n } from "../../translate/i18n";

const CHANNELS = [
	{
		name: "WhatsApp",
		bg: "#25D366",
		icon: (
			<svg width="20" height="20" viewBox="0 0 24 24" fill="white" aria-hidden>
				<path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413z" />
			</svg>
		),
	},
	{
		name: "Instagram",
		bg: "linear-gradient(135deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%)",
		icon: (
			<svg width="20" height="20" viewBox="0 0 24 24" fill="white" aria-hidden>
				<path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z" />
			</svg>
		),
	},
	{
		name: "Facebook",
		bg: "#1877F2",
		icon: (
			<svg width="20" height="20" viewBox="0 0 24 24" fill="white" aria-hidden>
				<path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
			</svg>
		),
	},
	{
		name: "Mercado Livre",
		bg: "#FFE600",
		icon: (
			<svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden>
				<path
					d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 14H9V8h2v8zm4 0h-2V8h2v8z"
					fill="#333"
				/>
			</svg>
		),
	},
	{
		name: "OLX",
		bg: "#8B5CF6",
		icon: (
			<svg width="20" height="20" viewBox="0 0 24 24" fill="white" aria-hidden>
				<text x="2" y="17" fontSize="13" fontWeight="bold" fontFamily="Arial">
					OLX
				</text>
			</svg>
		),
	},
	{
		name: "TikTok",
		bg: "#010101",
		icon: (
			<svg width="20" height="20" viewBox="0 0 24 24" fill="white" aria-hidden>
				<path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 0 0-.79-.05 6.34 6.34 0 0 0-6.34 6.34 6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.33-6.34l-.01-8.83a8.18 8.18 0 0 0 4.78 1.52V4.54a4.85 4.85 0 0 1-1-.15z" />
			</svg>
		),
	},
];

function BrandMark({ light = false }) {
	const productName = process.env.REACT_APP_NOME || "PluggMe";

	return (
		<div className="flex items-center gap-2.5">
			<div className="flex h-8 w-8 items-center justify-center rounded-lg bg-emerald-400">
				<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden>
					<path
						d="M8 1.5C4.41 1.5 1.5 4.41 1.5 8c0 1.15.3 2.23.82 3.16L1.5 14.5l3.34-.82A6.48 6.48 0 0 0 8 14.5c3.59 0 6.5-2.91 6.5-6.5S11.59 1.5 8 1.5z"
						fill="white"
					/>
				</svg>
			</div>
			<div>
				<span
					className={`text-lg font-bold tracking-tight ${
						light ? "text-white" : "text-zinc-900"
					}`}
				>
					{productName}
				</span>
				{light && (
					<p className="mt-0.5 text-[10px] uppercase leading-none tracking-widest text-white/60">
						{i18n.t("login.hero.productSubtitle")}
					</p>
				)}
			</div>
		</div>
	);
}

function AuthSplitLayout({ children, testId }) {
	return (
		<div
			className="flex min-h-screen w-full bg-white font-sans"
			data-testid={testId}
		>
			<div className="relative hidden flex-col justify-between overflow-hidden lg:flex lg:w-1/2">
				<img
					src="/assets/auth/login-hero.jpg"
					alt=""
					className="absolute inset-0 h-full w-full object-cover"
				/>
				<div className="absolute inset-0 bg-gradient-to-b from-black/60 via-transparent to-black/70" />

				<div className="relative z-10 flex items-center gap-2.5 p-10">
					<BrandMark light />
				</div>

				<div className="relative z-10 p-10">
					<p className="mb-4 max-w-xs text-xl font-semibold leading-snug text-white">
						{i18n.t("login.hero.tagline")}
					</p>
					<div className="flex flex-wrap gap-2">
						{CHANNELS.map((channel) => (
							<div
								key={channel.name}
								className="flex items-center gap-1.5 rounded-full border border-white/20 bg-white/10 px-3 py-1 backdrop-blur-sm"
							>
								<div
									className="flex h-4 w-4 shrink-0 items-center justify-center rounded-full"
									style={{ background: channel.bg }}
								>
									<span className="block scale-[0.5]">{channel.icon}</span>
								</div>
								<span className="text-xs font-medium text-white">{channel.name}</span>
							</div>
						))}
					</div>
				</div>
			</div>

			<div className="flex w-full items-center justify-center px-6 py-12 lg:w-1/2">
				<div className="w-full max-w-md">
					<div className="mb-8 flex items-center gap-2.5 lg:hidden">
						<BrandMark />
					</div>

					{children}
				</div>
			</div>
		</div>
	);
}

export default AuthSplitLayout;
